"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * Utility functions.
 */
var util = {
  /**
   * Converts a string to capital case.
   */
  toCapitalCase: function toCapitalCase(string) {
    return string.replace(/\b[a-z]/g, function (x) {
      return x.toUpperCase();
    });
  }
};
/**
 * Initiates all "Slider Two Slides" sections.
 */

var initiateAllSliderTwoSides = function initiateAllSliderTwoSides() {
  if (!window.tns) return;
  var sliderSections = document.querySelectorAll('[data-slider-two-sides]');
  sliderSections.forEach(function (sliderSection) {
    var sectionDataNode = sliderSection.parentElement.querySelector('[data-section-data]');
    var sectionData = JSON.parse(sectionDataNode.innerHTML);
    var sliderSlidesContainer = sliderSection.querySelector('.slider-slides');
    var sliderArrowNext = sliderSection.querySelector('.slider-next');
    var sliderArrowPrevious = sliderSection.querySelector('.slider-previous');
    var sliderOptions = {
      container: sliderSlidesContainer,
      prevButton: sliderArrowPrevious,
      nextButton: sliderArrowNext,
      autoplay: sectionData.should_autoplay,
      autoplayTimeout: sectionData.autoplay * 1000,
      autoplayButtonOutput: false,
      nav: false
    };
    var slider = tns(sliderOptions);
  });
};
/**
 * Testimonials modal tns slider
 */


var initiateTestimonialsSlider = function initiateTestimonialsSlider() {
  if (!window.tns) return;
  var testimonialsSlider = document.getElementById('TestimonialsSlider');
  if (!testimonialsSlider) return;
  var sliderArrowPrevious = testimonialsSlider.querySelector('[data-controls="prev"]');
  var sliderArrowNext = testimonialsSlider.querySelector('[data-controls="next"]');
  var sliderOptions = {
    container: testimonialsSlider,
    prevButton: sliderArrowPrevious,
    nextButton: sliderArrowNext,
    nav: false,
    controls: true,
    controlsContainer: '.controlsContainer',
    animateIn: 'tns-fadeIn',
    mode: 'gallery'
  };
  var initTestimonialsSlider = tns(sliderOptions);
  var modalTrigger = document.querySelectorAll('[data-modal-trigger]');
  var triggered = null;
  modalTrigger.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      document.body.classList.add('testimonial-modal-visible');
      triggered = trigger.getAttribute('data-modal-trigger');
      initTestimonialsSlider.goTo(Number(triggered) - 1);
    });
  });
  var modalTriggerClose = document.querySelectorAll('[data-trigger-modal-close]');
  modalTriggerClose.forEach(function (trigger) {
    trigger.addEventListener('click', function (evt) {
      if (typeof evt.target.dataset.triggerModalClose === 'undefined') {
        return;
      }

      document.body.classList.remove('testimonial-modal-visible');
    });
  });
};
/**
 * Populates the individual meals on the order page for all bundles in an order.
 * This is for the two store setup. The parent child order system does this directly in liquid.
 */


var displayBundleMealsOnOrderPage = function displayBundleMealsOnOrderPage() {
  /**
   * The script tag that holds the _product_data line item property for each bundle product.
   * This data is populated in /templates/customers/order.liquid
   */
  var bundleJSONTag = document.querySelector('.BundleJSON');

  if (bundleJSONTag) {
    var bundleData = JSON.parse(bundleJSONTag.innerHTML);
    bundleData.forEach(function (_ref) {
      var id = _ref.id,
          _product_data = _ref._product_data;

      /**
       * The table row that corresponds to this bundle.
       */
      var lineItemRow = document.querySelector("[data-line-item-id=\"".concat(id, "\"]"));
      /**
       * Get all the unique meal types in this bundle.
       */

      var mealTypes = _product_data.reduce(function (accumulator, _ref2) {
        var type = _ref2.type;
        return accumulator.includes(type) ? accumulator : [].concat(_toConsumableArray(accumulator), [type]);
      }, []);
      /**
       * Loop over each meal type, get all meals from the bundle of that type, and build out the html.
       *
       */


      var allMealsHTML = '';
      mealTypes.forEach(function (mealType) {
        var mealTypeHTML = "\n        <h3>".concat(util.toCapitalCase(mealType), "</h3>\n        ");
        /**
         * Get all meals from the bundle that match that type.
         */

        var mealTypeMeals = _product_data.filter(function (_ref3) {
          var type = _ref3.type;
          return type === mealType;
        });

        mealTypeMeals.forEach(function (_ref4) {
          var title = _ref4.title,
              quantity = _ref4.quantity;
          mealTypeHTML = mealTypeHTML.concat("\n          <div class=\"order-child-order-item\">\n            <div>".concat(title, "</div>\n            <div>").concat(quantity, "</div>\n          </div>\n          "));
        });
        allMealsHTML = allMealsHTML.concat(mealTypeHTML);
      });
      /**
       * Insert the constructed HTML as a table row after the bundle line item row.
       */

      var tableRowHTML = "\n        <tr data-product-data=\"".concat(id, "\">\n          <td colspan=\"6\">\n          ").concat(allMealsHTML, "\n          </td>\n        </tr>\n        ");
      lineItemRow.insertAdjacentHTML('afterend', tableRowHTML);
    });
  }
};
/**
 * Intialises all functions once the document loads.
 */


window.addEventListener('DOMContentLoaded', function () {
  displayBundleMealsOnOrderPage();
  initiateAllSliderTwoSides();
  initiateTestimonialsSlider();
});